<template>
  <div>
    <div class="card">
      <Toolbar class="mb-6">
        <template #start>
          <Button
            label="Nouveau"
            icon="pi pi-plus"
            class="mr-2"
            @click="openNew"
          />
          <Button
            label="Supprimer"
            icon="pi pi-trash"
            severity="danger"
            variant="outlined"
            @click="confirmDeleteSelected"
            :disabled="!selectedEmojiLinks.length"
          />
        </template>

<!--        <template #end>
          <Button
            label="Exporter"
            icon="pi pi-upload"
            severity="secondary"
            @click="exportCSV($event)"
          />
        </template>-->
      </Toolbar>

      <DataTable
        ref="dt"
        v-model:selection="selectedEmojiLinks"
        :value="emojiLinks"
        dataKey="id"
        :paginator="true"
        :rows="10"
        :filters="filters"
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
        :rowsPerPageOptions="[5, 10, 25]"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} emoji links"
      >
        <template #header>
          <div class="flex flex-wrap gap-2 items-center justify-between">
            <h4 class="m-0">Gestion de transfert message WhatsApp par emojis</h4>
            <IconField>
              <!--<InputIcon>
                <i class="pi pi-search" />
              </InputIcon>-->
              <InputText
                v-model="filters['global'].value"
                placeholder="Rechercher..."
              />
            </IconField>
          </div>
        </template>

        <Column
          selectionMode="multiple"
          style="width: 3rem"
          :exportable="false"
        />
        <Column
          field="phone_number"
          header="Numéro WhatsApp"
          sortable
          style="min-width: 14rem"
        />
                <Column
          field="id_group"
          header="id group"
          sortable
          style="min-width: 14rem"
        />
                <Column
          field="name_group"
          header="Non group"
          sortable
          style="min-width: 14rem"
        />
                <Column
          field="name_profile"
          header="Profile"
          sortable
          style="min-width: 14rem"
        />
        <Column field="emoji" header="Emoji" sortable style="min-width: 6rem" />
        <Column :exportable="false" style="min-width: 10rem">
          <template #body="slotProps">
            <Button
              icon="pi pi-pencil"
              variant="outlined"
              rounded
              class="mr-2"
              @click="editEmojiLink(slotProps.data)"
            />
            <Button
              icon="pi pi-trash"
              variant="outlined"
              rounded
              severity="danger"
              @click="confirmDeleteEmojiLink(slotProps.data)"
            />
          </template>
        </Column>
      </DataTable>
    </div>

    <Dialog
      v-model:visible="emojiDialog"
      :style="{ width: '450px' }"
      header="Ajouter/ Mise à jour"
      :modal="true"
    >
      <div class="flex flex-col gap-6">
       <!-- <div>
          <label for="phone_number" class="block font-bold mb-3"
            >Numéro WhatsApp</label
          >
          <InputText
            id="phone_number"
            v-model.trim="emojiLink.phone_number"
            required
            autofocus
            :invalid="submitted && !emojiLink.phone_number"
          />
          <small
            v-if="submitted && !emojiLink.phone_number"
            class="text-red-500"
            >Ce champ est requis.</small
          >
        </div>-->

        <div>
          <label for="emoji" class="block font-bold mb-3">Emoji</label>
          <InputText
            id="emoji"
            v-model.trim="emojiLink.emoji"
            required
            :invalid="submitted && !emojiLink.emoji"
          />
          <small v-if="submitted && !emojiLink.emoji" class="text-red-500"
            >Ce champ est requis.</small
          >
        </div>
      </div>

      <template #footer>
        <Button label="Annuler" icon="pi pi-times" text @click="hideDialog" />
        <Button label="Enregistrer" icon="pi pi-check" @click="saveEmojiLink" />
      </template>
    </Dialog>

    <!-- Dialogs confirmation suppression -->
    <Dialog
      v-model:visible="deleteEmojiLinkDialog"
      :style="{ width: '450px' }"
      header="Confirmation"
      :modal="true"
    >
      <div class="flex items-center gap-4">
        <i class="pi pi-exclamation-triangle text-3xl" />
        <span
          >Confirmer la suppression de
          <b>{{ emojiLink.phone_number }}</b> ?</span
        >
      </div>
      <template #footer>
        <Button
          label="Non"
          icon="pi pi-times"
          text
          @click="deleteEmojiLinkDialog = false"
        />
        <Button
          label="Oui"
          icon="pi pi-check"
          @click="deleteEmojiLink"
          severity="danger"
        />
      </template>
    </Dialog>

    <Dialog
      v-model:visible="deleteEmojiLinksDialog"
      :style="{ width: '450px' }"
      header="Confirmation"
      :modal="true"
    >
      <div class="flex items-center gap-4">
        <i class="pi pi-exclamation-triangle text-3xl" />
        <span>Supprimer les entrées sélectionnées ?</span>
      </div>
      <template #footer>
        <Button
          label="Non"
          icon="pi pi-times"
          text
          @click="deleteEmojiLinksDialog = false"
        />
        <Button
          label="Oui"
          icon="pi pi-check"
          text
          @click="deleteSelectedEmojiLinks"
          severity="danger"
        />
      </template>
    </Dialog>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
//import { FilterMatchMode } from "@primevue/api";
import { useToast } from "primevue/usetoast";
import axios from "axios";
import { API_URL } from "../settings";

const toast = useToast();
const dt = ref();
const emojiLinks = ref([]);
const selectedEmojiLinks = ref([]);
const emojiLink = ref({});
const emojiDialog = ref(false);
const deleteEmojiLinkDialog = ref(false);
const deleteEmojiLinksDialog = ref(false);
const submitted = ref(false);

const filters = ref({
  global: { value: null },
});


onMounted(() => {
  loadEmojiLinks();
});

const loadEmojiLinks = async () => {
  const response = await axios.get(`${API_URL}api/mc_chat/emoji-links`);
  emojiLinks.value = response.data;
};

const openNew = () => {
  emojiLink.value = {};
  submitted.value = false;
  emojiDialog.value = true;
};

const hideDialog = () => {
  emojiDialog.value = false;
  submitted.value = false;
};

const saveEmojiLink = async () => {
  submitted.value = true;

  if (!emojiLink.value.emoji) return;

  try {
    if (emojiLink.value.id) {
      const response = await axios.put(
        `${API_URL}api/mc_chat/emoji-links-only/${emojiLink.value.id}`,
        emojiLink.value
      );
      const index = emojiLinks.value.findIndex(
        (e) => e.id === emojiLink.value.id
      );
      emojiLinks.value[index] = response.data;
      toast.add({
        severity: "success",
        summary: "Modifié",
        detail: "EmojiLink mis à jour",
        life: 3000,
      });
    } else {
      const response = await axios.post(
        `${API_URL}api/mc_chat/emoji-links`,
        emojiLink.value
      );
      emojiLinks.value.push(response.data);
      toast.add({
        severity: "success",
        summary: "Ajouté",
        detail: "EmojiLink créé",
        life: 3000,
      });
    }

    emojiDialog.value = false;
    emojiLink.value = {};
  } catch (error) {
    toast.add({
      severity: "error",
      summary: "Erreur",
      detail: "Opération échouée",
      life: 3000,
    });
  }
};

const editEmojiLink = (link) => {
  emojiLink.value = { ...link };
  emojiDialog.value = true;
};

const confirmDeleteEmojiLink = (link) => {
  emojiLink.value = link;
  deleteEmojiLinkDialog.value = true;
};

const deleteEmojiLink = async () => {
  try {
    await axios.delete(
      `${API_URL}api/mc_chat/emoji-links/${emojiLink.value.id}`
    );
    emojiLinks.value = emojiLinks.value.filter(
      (e) => e.id !== emojiLink.value.id
    );
    toast.add({
      severity: "success",
      summary: "Supprimé",
      detail: "EmojiLink supprimé",
      life: 3000,
    });
  } catch (error) {
    toast.add({
      severity: "error",
      summary: "Erreur",
      detail: "Échec suppression",
      life: 3000,
    });
  }

  deleteEmojiLinkDialog.value = false;
  emojiLink.value = {};
};

const confirmDeleteSelected = () => {
  deleteEmojiLinksDialog.value = true;
};

const deleteSelectedEmojiLinks = async () => {
  for (const item of selectedEmojiLinks.value) {
    await axios.delete(`${API_URL}api/mc_chat/emoji-links/${item.id}`);
  }
  emojiLinks.value = emojiLinks.value.filter(
    (e) => !selectedEmojiLinks.value.includes(e)
  );
  selectedEmojiLinks.value = [];
  deleteEmojiLinksDialog.value = false;
  toast.add({
    severity: "success",
    summary: "Supprimés",
    detail: "Sélection supprimée",
    life: 3000,
  });
};

// const exportCSV = () => {
//   dt.value.exportCSV();
// };
</script>
